const hilightLinkMCSLink = (str) => {
  const result = str.replace(
    "@mcs_eth",
    `<span style="color:rgb(0, 111, 214);font-weight:600">@guidedao</span>`
  );
  return result;
};

export default hilightLinkMCSLink;
